import { create } from 'zustand';
import type { Metrics } from '~/features/measure/interfaces/models';
import type { UnixTime } from '~/interfaces/common';
import { currentDateTime, getCurrentSeconds } from '~/utils/time';

// 計測フォームの初期値（API応答到着前のフォールバック）
export const initialMetrics: Metrics = {
  height: 0,
  weight: 0,
  right_length: 0,
  right_circumference: 0,
  left_length: 0,
  left_circumference: 0,
};

interface MeasureState {
  // ユーザーが現在入力している計測値
  currentMetrics: Metrics;
  // localStorageから復元した直前のドラフト値（あれば優先される）
  defaultMetrics: Metrics | undefined;
  // ユーザーが値を変更したUnix秒。POST時のmeasurement_dateとして使う
  measurementDate: UnixTime;
  // initFromApi 実行済みフラグ。persist useEffect の初回ガードに使う
  isInitialized: boolean;
  // 1メトリクスを更新（measurementDateも自動更新）
  setMetric: <K extends keyof Metrics>(key: K, value: Metrics[K]) => void;
  // API応答到着時に1度だけ呼び出す初期化アクション
  initFromApi: (lastMetrics: Metrics, fromPersistence: Metrics | undefined) => void;
  // 状態をリセット（テストや再計測のため）
  reset: () => void;
}

export const useMeasureStore = create<MeasureState>((set) => ({
  currentMetrics: initialMetrics,
  defaultMetrics: undefined,
  measurementDate: getCurrentSeconds(),
  isInitialized: false,

  setMetric: (key, value) =>
    set((state) => ({
      currentMetrics: {
        ...state.currentMetrics,
        [key]: value,
      },
      measurementDate: currentDateTime().toSeconds(),
    })),

  initFromApi: (lastMetrics, fromPersistence) =>
    set({
      currentMetrics: fromPersistence ?? lastMetrics,
      defaultMetrics: fromPersistence ?? lastMetrics,
      measurementDate: getCurrentSeconds(),
      isInitialized: true,
    }),

  reset: () =>
    set({
      currentMetrics: initialMetrics,
      defaultMetrics: undefined,
      measurementDate: getCurrentSeconds(),
      isInitialized: false,
    }),
}));
